import React, { Component } from 'react';
import { Manager, Reference, Popper } from 'react-popper';
import { FormattedMessage } from 'react-intl';
import { Input, Label, FormGroup } from 'reactstrap';
import CustomControl from '../CustomControl/CustomControl';
import Icon from '../Icon/Icon';

class StatisticsSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      data: {
        limit: 100,
        isPagination: true,
        isChart: true,
      },
    };

    this.$el = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.closeOnDocumentClick);

    const settings = localStorage.getItem('offerrum_statistics_settings');

    if (settings) {
      const data = JSON.parse(settings);
      this.props.onSettingsUpdate(data);
      this.setState(prevState => ({
        ...prevState,
        data: {
          ...prevState.data,
          ...data,
        }
      }));
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.closeOnDocumentClick);
  }

  closeOnDocumentClick = ({ target }) => {
    if (this.$el && !this.$el.current.contains(target)) {
      if (this.state.open) {
        this.close();
      }
    }
  };

  toggle = () => {
    if (this.state.open) {
      this.updateSettings();
    }
    this.setState(prevState => ({ open: !prevState.open }));
  };

  close = () => {
    this.setState(() => ({ open: false }), () => {
      this.updateSettings();
    });
  };

  onChange = ({ target }) => {
    const { name } = target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    this.setState(prevState => ({
      ...prevState,
      data: {
        ...prevState.data,
        [name]: target.type === 'number' ? value ?  parseInt(value) : 0 : value
      },
    }));
  };

  updateSettings = () => {
    const { data } = this.state;
    const { onSettingsUpdate } = this.props;

    localStorage.setItem('offerrum_statistics_settings', JSON.stringify(data));
    onSettingsUpdate(data);
  }

  render() {
    const {
      open,
      data: { isPagination, limit, isChart },
    } = this.state;
    return (
      <Manager>
        <div className="statistics-settings" ref={this.$el}>
          <Reference>
            {({ ref }) => (
              <button
                ref={ref}
                className="statistics-mini-button statistics-mini-button--settings btn btn-primary"
                onClick={this.toggle}
              >
                <Icon type="gear" />
              </button>
            )}
          </Reference>

          {open && (
            <Popper placement="bottom">
              {({ ref, style, placement, arrowProps }) => (
                <div
                  className="statistics-settings-container popover"
                  ref={ref}
                  style={style}
                  data-placement={placement}
                >
                  <div className="statistics-setting-header popover-header">
                    <FormattedMessage id="statistics.settings.title" defaultMessage="Settings" />
                    <Icon type="cross-rounded" className="statistics-setting-close" onClick={this.close}/>
                  </div>
                  <div className="statistics-setting-items popover-body">
                  <FormGroup className="statistics-settings-field">
                      <CustomControl
                        id={`isChart`}
                        name="isChart"
                        type="checkbox"
                        className="custom-control-xs"
                        value={1}
                        onChange={this.onChange}
                        checked={isChart}
                      >
                        <FormattedMessage
                          id="statistics.settings.chart"
                          defaultMessage="Display charts"
                        />
                      </CustomControl>
                    </FormGroup>
                    <FormGroup className="statistics-settings-field">
                      <CustomControl
                        id={`isPagination`}
                        name="isPagination"
                        type="checkbox"
                        className="custom-control-xs"
                        value={1}
                        onChange={this.onChange}
                        checked={isPagination}
                      >
                        <FormattedMessage
                          id="statistics.settings.pagination"
                          defaultMessage="Pagination"
                        />
                      </CustomControl>
                    </FormGroup>
                    {isPagination && (
                      <FormGroup className="no-margin statistics-settings-field">
                        <Input
                          id="limit"
                          name="limit"
                          placeholder="10"
                          bsSize="sm"
                          type="number"
                          value={limit}
                          onChange={this.onChange}
                        />
                        <Label for="limit" className="no-margin">
                          <FormattedMessage
                            id="statistics.settings.limit"
                            defaultMessage="Rows per page"
                          />
                        </Label>
                      </FormGroup>
                    )}
                  </div>
                  <span className="arrow" ref={arrowProps.ref} style={arrowProps.style} />
                </div>
              )}
            </Popper>
          )}
        </div>
      </Manager>
    );
  }
}

export default StatisticsSettings;
